'use client'

import { useEffect, useRef } from 'react'
import { isEmpty } from 'ramda'

import { useModal } from 'shared/ui/Modal/useModal'

import { CustomerAddress } from '../../types'

interface AutoOpenModalAddDeliveryAddressManagerProps {
  deliveryAddresses?: CustomerAddress[]
  children: React.FC<{
    isModalOpen: boolean
    openModal: () => void
    closeModal: () => void
  }>
}

const AutoOpenModalAddDeliveryAddressManager = ({
  deliveryAddresses,
  children
}: AutoOpenModalAddDeliveryAddressManagerProps) => {
  const { isModalOpen, openModal, closeModal } = useModal()
  const hasOpened = useRef<boolean>(false)

  // Open the add delivery address modal on page load if no delivery addresses exist

  useEffect(() => {
    const shouldAutoOpen =
      deliveryAddresses !== undefined &&
      isEmpty(deliveryAddresses) &&
      !hasOpened.current

    if (shouldAutoOpen) {
      hasOpened.current = true
      openModal()
    }
  }, [deliveryAddresses, openModal])

  return children({ isModalOpen, openModal, closeModal })
}

export default AutoOpenModalAddDeliveryAddressManager
